module.exports = {
    set_width: function() {
        if($('#drugchecking_iframe').length > 0) {
            $('#drugchecking_iframe').width($('#content').width());
        }
    }
}